export default __webpack_public_path__ + "static/media/video-placeholder-grey.58e7b817.jpg";